export const PENDING_REFERRAL_CODE_KEY = "pending_referral_code";

export function savePendingReferralCode(code: string) {
  const normalized = code.trim();
  if (normalized) localStorage.setItem(PENDING_REFERRAL_CODE_KEY, normalized);
}

export function getPendingReferralCode() {
  return localStorage.getItem(PENDING_REFERRAL_CODE_KEY);
}

export function clearPendingReferralCode() {
  localStorage.removeItem(PENDING_REFERRAL_CODE_KEY);
}

export function extractReferralCode(query: Record<string, unknown>) {
  const value = query.referral_code ?? query.referrer_id ?? query.ref;
  const normalized = Array.isArray(value) ? value[0] : value;
  return typeof normalized === "string" ? normalized.trim() : "";
}

export function buildReferralLink(referralCode: string) {
  const configuredUrl = import.meta.env.VITE_PUBLIC_WEB_URL?.trim();
  const origin = configuredUrl || window.location.origin;
  return `${origin.replace(/\/+$/, "")}/invite/${encodeURIComponent(referralCode)}`;
}
